import { render, staticRenderFns } from "./PassOlvidada.vue?vue&type=template&id=398d50b8"
import script from "./PassOlvidada.vue?vue&type=script&lang=js"
export * from "./PassOlvidada.vue?vue&type=script&lang=js"
import style0 from "./PassOlvidada.vue?vue&type=style&index=0&id=398d50b8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports